/* @flow */

export default class SendLeadToEdebexRequest {
  companyId: number;
  leadId: number;

  constructor(companyId: number, leadId: number) {
    this.companyId = companyId;
    this.leadId = leadId;
  }
}
